import { Injectable } from '@angular/core';
import { HttpService } from '../http/http.service';
import { PurchaseInvoice, PurchaseInvoiceRequest } from '../../interface/product/purchase-invoice/purchase-invoice';
import { firstValueFrom } from 'rxjs';
import { PagerBase } from '../../interface';
import { PaginationConfig } from 'src/app/shared/tables';

@Injectable({
  providedIn: 'root',
})
export class PurchaseInvoiceService {
  constructor(private _http: HttpService) { }

  public async get(id: number): Promise<PurchaseInvoice> {
    return await firstValueFrom(this._http.get('/PurchaseInvoices/' + id));
  }
    public async getRaw(id: number): Promise<PurchaseInvoice> {
    return await firstValueFrom(this._http.get('/PurchaseInvoices/' + id+'/raw'));
  }
  public async getDetail(id: number): Promise<PurchaseInvoice> {
    return await firstValueFrom(this._http.get('/PurchaseInvoices/' + id+'/detail'));
  }

  getAll(config?: PaginationConfig): Promise<PagerBase<PurchaseInvoice>> {
    return firstValueFrom(this._http.get('/PurchaseInvoices?number=' + ((config?.index ?? 0) + 1) + '&size=' + (config?.size ?? 10)));
  }

  create(data: PurchaseInvoiceRequest): Promise<any> {
    return firstValueFrom(this._http.post('/PurchaseInvoices', data));
  }

  public update(id: number, data: PurchaseInvoiceRequest): Promise<PurchaseInvoice> {
    return firstValueFrom(this._http.put('/PurchaseInvoices/', id, data));
  }
  public async void(id: number): Promise<void> {
    return firstValueFrom(this._http.post('/PurchaseInvoices/' + id + '/void', null));
  }
}
